module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_2"
    }
  }, [_vm._v("Unexpected Cargo")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Meanwhile, back in Sacramento….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Oops, Here I Go Again….")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0009#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Fish in a School")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0010#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Two Fish, One Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0011#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Big Fish, Little Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0012#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("A Familiar Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0013#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Worms and Hooks")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0014#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Big Fish Walking")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0015#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Extra Credit")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0016#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("A Little Chum")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0017#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Ducks, Row, Truck")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0018#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Fish Bowls in the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0019#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Swimming Fury")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0020#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Fish in a Bulletproof Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0021#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("The Early Morning Coffee Swim")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0022#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("It Takes a Fish Bowl to Save a School of Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0023#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("One Last Dirty Stinking Crappie")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0024#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("R.O.R.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0025#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Tails, Scales, and Epic Fails")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0026#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Belly Up or Still Swimming")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0027#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Fishy-versary")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0029#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Cold Water")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0032#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("That One Shirt")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0033#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("When Dave Met Alex—")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0037#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("More from Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0038#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Readers love the Fish Out of Water series by Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0039#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0040#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("By Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0041"
    }
  }, [_vm._v("Visit Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0042#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-676b2c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0001.vue
// module id = 57
// module chunks = 0